import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenInterceptor } from './interceptors/token-interceptor';
import { environment } from './../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ApplicationRef, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContentModule } from './content/content.module';
import {
  LogLevel,
  AuthModule as OIDCAuthModule,
} from 'angular-auth-oidc-client';

import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppConfigService } from './app.config.service';
import { ErrorHandlerService } from './utilities/logging.service';
import { EmailDialogComponent } from './content/home/components/email-dialog/email-dialog.component';
import { SendDialogComponent } from './glp-common/components/send-dialog/send-dialog.component';
import { HomeModule } from './content/home/home.module';
import { provideAuth0 } from '@auth0/auth0-angular';
import { UserService } from './services/user.service';


export function loadConfigService(configService: AppConfigService): Function {
  return () => {
    return configService.load();
  };
}

export function getAuth0ClientId() {
  // development logic
  if(document.baseURI.includes('localhost')){
    if(environment.redirectUrlBroker.includes('localhost')){
      return environment.auth0BrokerclientId
    }
    else if (environment.redirectUrlGL.includes('localhost')){
      return environment.auth0GLclientId ;
    }
  }


  if(document.baseURI.includes('broker')){
    return environment.auth0BrokerclientId;
  }
  else{
    return environment.auth0GLclientId ;
  }
};

export enum PortalVersion {
  EOA,
  BBP
}

export function getPortalVersion() : PortalVersion {
  // development logic
  if(document.baseURI.includes('localhost')){
    if(environment.redirectUrlBroker.includes('localhost')){
      return PortalVersion.BBP;
    }
    else if (environment.redirectUrlGL.includes('localhost')){
      return PortalVersion.EOA;
    }
  }


  if(document.baseURI.includes('broker')){
    return PortalVersion.BBP;
  }
  else{
    return PortalVersion.EOA ;
  }
};


@NgModule({
  declarations: [AppComponent,EmailDialogComponent, SendDialogComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    AppRoutingModule,
    ContentModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    MaterialModule,
    BrowserAnimationsModule,
    HttpClientModule,
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigService,
      deps: [AppConfigService, Sentry.TraceService],
      multi: true,
    },
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: getAuth0ClientId(),
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      cacheLocation: 'localstorage',
      authorizationParams: {
        redirect_uri: window.location.origin,
      },
      
    }),
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
